import React, { Fragment, useState, useRef } from "react";
import { Form, Modal, Button, Nav, Tab, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import SignatureCanvas from 'react-signature-canvas';
import * as Api from "../../General/api";
import * as Common from "../../General/common";
import { apiUrls } from "../../constants/endpoints";


const filterResidentsByAob = (medBResidents) => {
  if (!Array.isArray(medBResidents) || medBResidents.length === 0) {
    return { residentsWithAOB: [], residentsWithoutAOB: [] };
  }

  const hasAobUrl = (resident) => {
    const url = resident.aobPdfUrl ?? "";
    return typeof url === "string" ? url.trim() !== "" : Boolean(url);
  };

  const residentsWithAOB = medBResidents.filter(hasAobUrl);
  const residentsWithoutAOB = medBResidents.filter((r) => !hasAobUrl(r));

  return { residentsWithAOB, residentsWithoutAOB };
};


const AOBManagement = (props) => {
  const { user } = useSelector((state) => state.auth);
  const signatureRef = useRef(null);
  const [selectedResidents, setSelectedResidents] = useState([]);
  const [filterWithoutAob, setFilterWithoutAob] = useState(true);
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const [representativeName, setRepresentativeName] = useState("");
  const [representativeTitle, setRepresentativeTitle] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);

  const residentList = props.residentList ?? [];
  // one more check for medBResidents, residentList contain those residents only with isMedB = true
  const medBResidents = residentList.filter((r) => r.isMedB === true);
  const { residentsWithAOB, residentsWithoutAOB } = filterResidentsByAob(medBResidents);

  debugger;
  // This function is for checkbox changing
  const handleCheckboxChange = (resident, isChecked) => {
    if (isChecked) {
      setSelectedResidents((prev) => [...prev, resident]);
    } else {
      setSelectedResidents((prev) => prev.filter((r) => r.id !== resident.id));
    }
  };

  // Check for when we select a resident is it in the selectedResidents array.
  const isResidentSelected = (residentId) =>
    selectedResidents.some((r) => r.id === residentId);

  // Download AOB handler — generates blank printable AOB form per selected resident
  const handleDownloadAOB = async () => {
    debugger;
    if (selectedResidents.length === 0) {
      Common.showSuccessAlert(
        "Please select at least one resident",
        "warning",
        "No Selection"
      );
      return;
    }

    try {
      setIsGenerating(true);

      const payload = {
        residentIds: selectedResidents.map((r) => r.id),
        facilityName: props.facilityName || "",
      };

      const response = await Api.postRequest(apiUrls.downloadBlankAobForms, payload, false);
      const { success, message, result } = response.data;
      const pdfs = result?.pdfs || [];

      // Trigger browser download for each PDF (backend only sends successful ones)
      debugger;
      for (const pdf of pdfs) {
        const byteChars = atob(pdf.pdfBase64);
        const byteArray = new Uint8Array(byteChars.length);
        for (let i = 0; i < byteChars.length; i++) {
          byteArray[i] = byteChars.charCodeAt(i);
        }
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = pdf.fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      }

      const hasFailed = result?.failedCount > 0;
      if (success) {
        // Show auto-close success popup same as "Resident Processed Successfully"
        Common.showSuccessAlertAutoClose(
          message,
          hasFailed ? "warning" : "success",
          hasFailed ? "Partial Success!" : "Success!",
          4000
        );
        setSelectedResidents([]);
      } else {
        Common.showSuccessAlert(message || "Failed to generate AOB forms", "error", "Error!");
      }
    } catch (error) {
      console.error("Error downloading blank AOB forms:", error);
      Common.showSuccessAlert(
        "An error occurred while generating AOB forms",
        "error",
        "Error!"
      );
    } finally {
      setIsGenerating(false);
    }
  };

  // GenerateAOB handler
  const handleGenerateAOBs = async () => {
    debugger;
    if (!signatureRef.current || signatureRef.current.isEmpty()) {
      Common.showSuccessAlert(
        "Please provide a signature",
        "warning",
        "Signature Required",
        3000
      );
      return;
    }

    if (!representativeName.trim()) {
      Common.showSuccessAlert(
        "Please enter representative name",
        "warning",
        "Name Required",
        3000
      );
      return;
    }

    if (!representativeTitle.trim()) {
      Common.showSuccessAlert(
        "Please enter representative title",
        "warning",
        "Title Required",
        3000
      );
      return;
    }

    try {
      setIsGenerating(true);

      const signatureBase64 = signatureRef.current.toDataURL();

      debugger;
      const items = selectedResidents.map((r) => ({
        residentId: r.id,
        residentName: [r.firstName, r.lastName].filter(Boolean).join(" ") || Common.replaceNullWithString(r.firstName) + " " + Common.replaceNullWithString(r.lastName),
        facilityName: Common.replaceNullWithString(r.facilityName || props.facilityName || ""),
        medicareId: Common.replaceNullWithString(r.medicare),
        primaryInsurance: Common.replaceNullWithString(r.primaryInsurance) ?? "",
        secondaryInsurance: Common.replaceNullWithString(r.secondaryInsurance) ?? "",
        todayDate: r.todayDate || new Date().toLocaleDateString(), // or your preferred format
        representativeName: representativeName.trim(),
        representativeTitle: representativeTitle.trim(),
        // optional: set to false/empty if backend expects them and UI doesn’t collect yet
        isPatientRights: false,
        isPatientResponsibilities: false,
        isFinancialResponsibility: false,
        isAssignmentRelease: false,
        isCompanyInformation: false,
        isTelephoneNumber: false,
        isWarrantyInformation: false,
        isPracticesNotice: false,
        isCopyOfSupplier: false,
        isPhysicallyAble: false,
        reasonUnableToSign: null,
        isAobWithFacility: false,
      }));

      debugger;
      // payload may include checkboxes as well.
      const payload = {
        signatureImageBase64: signatureBase64,
        items
      };

      const response = await Api.postRequest(apiUrls.generateAobPdf, payload, false);

      if (response.data.success === true) {
        Common.showSuccessAlert(
          response.data.message || `Successfully generated ${selectedResidents.length} AOB PDF(s)`,
          "success",
          "Success",
          3000
        );
        setShowSignatureModal(false);
        setSelectedResidents([]);
        setRepresentativeName("");
        setRepresentativeTitle("");
        if (signatureRef.current) signatureRef.current.clear();
        if (props.onRefresh) props.onRefresh();
      } else {
        Common.showSuccessAlert(
          response.data.message || "Failed to generate AOB PDFs",
          "error",
          "Error",
          3000
        );
      }
    } catch (error) {
      console.error("Error generating AOB PDFs:", error);
      Common.showSuccessAlert(
        "An error occurred while generating AOB PDFs",
        "error",
        "Error",
        3000
      );
    } finally {
      setIsGenerating(false);
    }
  };

  // Some signature modal which may be is for the signing functionality.
  const handleCloseSignatureModal = () => {
    setShowSignatureModal(false);
    setRepresentativeName("");
    setRepresentativeTitle("");
    if (signatureRef.current) signatureRef.current.clear();
  };

  // Clear signature functionality
  const handleClearSignature = () => {
    if (signatureRef.current) signatureRef.current.clear();
  };

  // Handle elctronic signing functionality
  const handleInitiateElectronicSigning = () => {
    if (selectedResidents.length === 0) {
      Common.showSuccessAlert(
        "Please select at least one resident",
        "warning",
        "No Selection",
        3000
      );
      return;
    }
    const residentIds = selectedResidents.map((r) => r.id);
    console.log("Initiate electronic signing for residents:", residentIds);
    Common.showSuccessAlert(
      `Initiating electronic signing for ${selectedResidents.length} resident(s)`,
      "info",
      "Process Started",
      3000
    );
  };


  const handleCloseModal = () => {
    setSelectedResidents([]);
    setFilterWithoutAob(true);
    props.onClose();
  };

  const onTabSelect = (k) => {
    debugger;
    setFilterWithoutAob(k === "true");
    setSelectedResidents([]);
  };

  // render table is the table for residents to be displayed.
  const renderTable = (residents) => {
    if (residents.length === 0) {
      return (
        <div className="alert alert-info" role="alert">
          No residents found.
        </div>
      );
    }



    return (
      <table className="table table-hover">
        <thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
          <tr className="fw-bold">
            <th>First Name</th>
            <th>Last Name</th>
            <th>DOB</th>
            <th>Unit/Room</th>
            {filterWithoutAob ? (
              <th width="80px" className="text-center">Select</th>
            ) : (
              <th width="60px" className="text-center">AOB</th>
            )}
          </tr>
        </thead>
        <tbody>
          {residents.map((resident) => (
            <tr key={resident.id}>
              <td>{Common.replaceNullWithString(resident.firstName)}</td>
              <td>{Common.replaceNullWithString(resident.lastName)}</td>
              <td>{resident.doB ? Common.GetDateString(resident.doB) : "N/A"}</td>
              <td>
                {Common.replaceNullWithString(resident.unit)}/
                {Common.replaceNullWithString(resident.room)}
              </td>
              {filterWithoutAob ? (
                <td className="text-center">
                  <input
                    type="checkbox"
                    checked={isResidentSelected(resident.id)}
                    onChange={(e) => handleCheckboxChange(resident, e.target.checked)}
                    style={{ width: 18, height: 18, cursor: "pointer" }}
                  />
                </td>
              ) : (
                <td className="text-center">
                  <Button
                    variant="link"
                    size="sm"
                    className="p-0"
                    onClick={() => resident.aobPdfUrl && window.open(resident.aobPdfUrl, "_blank")}
                    disabled={!resident.aobPdfUrl}
                    title="View AOB"
                  >
                    <span className="fa fa-file-pdf fa-lg text-danger" />
                  </Button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <Fragment>
      <Modal
        size="lg"
        centered
        scrollable
        backdrop="static"
        keyboard={false}
        show={props.open}
        onHide={handleCloseModal}
      >
        <Modal.Header className="py-2" closeButton>
          <span className="align-middle">AOB Management</span>
        </Modal.Header>

        <Modal.Body className="py-2">
          <div className="mb-3">
            <p className="text-muted" style={{ fontSize: "0.85rem" }}>
              <strong>View and manage Assignment of Benefits (AOB) documents for Medicare residents.</strong>
              <br />
              Select resident(s) without an AOB on file to download or electronically sign AOBs.
              <br />
              One signature may be applied to multiple residents.
              <hr />
            </p>

          </div>

          <Form>
            <Tab.Container activeKey={filterWithoutAob ? "true" : "false"} onSelect={onTabSelect}>
              <Nav variant="pills" className="d-flex justify-content-center mb-3" style={{ gap: "8px" }}>
                <Nav.Item>
                  <Nav.Link
                    eventKey="false"
                    style={{
                      backgroundColor: !filterWithoutAob? "#28A745" : "transparent",
                      borderColor: "#28A745",
                      border: "1px solid #28A745",
                      color: !filterWithoutAob ? "#fff" : "#28A745",
                      borderRadius: "4px",
                      padding: "6px 20px",
                    }}
                  >
                    With AOB
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="true"
                    style={{
                      backgroundColor: filterWithoutAob? "#DC3545" : "transparent",
                      borderColor: "#DC3545",
                      border: "1px solid #DC3545",
                      color: filterWithoutAob? "#fff" : "#DC3545",
                      borderRadius: "4px",
                      padding: "6px 20px",
                    }}
                  >
                    Without AOB
                  </Nav.Link>
                </Nav.Item>
              </Nav>

              <Tab.Content>
                <Tab.Pane eventKey="false">
                  <div style={{ height: "350px", overflowY: "auto" }}>
                    {renderTable(residentsWithAOB)}
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="true">
                  <div style={{ height: "350px", overflowY: "auto" }}>
                    {renderTable(residentsWithoutAOB)}
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Form>
        </Modal.Body>

        <Modal.Footer className="py-2" style={{ justifyContent: "flex-end" }}>
          {filterWithoutAob && (
            <>
              <Button
                variant="outline-secondary"
                className="btn-sm"
                onClick={handleDownloadAOB}
                disabled={selectedResidents.length === 0 || isGenerating}
                style={{ marginRight: "0.5rem" }}
              >
                {isGenerating ? (
                  <>
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="mr-1" />
                    <span className="align-middle"> Generating...</span>
                  </>
                ) : (
                  <>
                    <i className="fas fa-download mr-1"></i>
                    <span className="align-middle"> Download AOB(s)</span>
                  </>
                )}
              </Button>
              <Button
                variant="primary"
                className="btn-sm"
                onClick={handleInitiateElectronicSigning}
                disabled={selectedResidents.length === 0}
                style={{ marginRight: "0.5rem" }}
              >
                <span className="align-middle">Initiate Electronic Signing</span>
              </Button>
            </>
          )}
          <Button variant="danger" className="btn-sm" onClick={handleCloseModal}>
            <span className="align-middle">Close</span>
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Signature Capture Modal */}
      <Modal
        size="md"
        centered
        backdrop="static"
        keyboard={false}
        show={showSignatureModal}
        onHide={handleCloseSignatureModal}
      >
        <Modal.Header className="py-2" closeButton>
          <span className="align-middle">Capture Signature for AOB</span>
        </Modal.Header>

        <Modal.Body className="py-2">
          <p className="text-muted mb-3">
            Please provide your signature and information. This signature will be applied to all{" "}
            {selectedResidents.length} selected resident(s).
          </p>

          <Form>
            <Form.Group className="mb-3">
              <Form.Label>
                Representative Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter representative name"
                value={representativeName}
                onChange={(e) => setRepresentativeName(e.target.value)}
                disabled={isGenerating}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>
                Representative Title <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter representative title"
                value={representativeTitle}
                onChange={(e) => setRepresentativeTitle(e.target.value)}
                disabled={isGenerating}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>
                Signature <span className="text-danger">*</span>
              </Form.Label>
              <div
                className="border rounded p-2 bg-white"
                style={{ width: "100%", display: "flex", justifyContent: "center" }}
              >
                <SignatureCanvas
                  ref={signatureRef}
                  penColor="green"
                  canvasProps={{ width: 450, height: 120, className: "signature-canvas" }}
                />
              </div>
              <div className="mt-2">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={handleClearSignature}
                  disabled={isGenerating}
                >
                  Clear Signature
                </Button>
              </div>
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer className="py-2">
          <Button
            variant="secondary"
            size="sm"
            onClick={handleCloseSignatureModal}
            disabled={isGenerating}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="sm"
            onClick={handleGenerateAOBs}
            disabled={isGenerating}
          >
            {isGenerating ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="mr-2"
                />
                Generating...
              </>
            ) : (
              `Generate AOB(s) for ${selectedResidents.length} Resident(s)`
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default AOBManagement;
